module.exports = __webpack_public_path__ + "media/images/dyszkiewicz-dbc011a6.jpeg";